import React, { Fragment } from 'react';
import { useParams } from "react-router";

// Material UI
import { Divider, Grid, Paper, Typography, Box } from "@mui/material";

// Components
import Spinner from "../../../components/spinner";
import Info from "../totals/Info";

// Hooks
import useArching from "../../../hooks/archings/useArching";

// Models
import { cashTypes, cashTypesFormat } from "../../../models/CashRegisterMovementEntity";

// Others
import { utils } from "../../../utils/utils";
import useUser from '../../../hooks/user/useUser';

const ArchingDetail = () => {
    const { archingId } = useParams();
    const { arching, loading } = useArching(archingId);
    const { business } = useUser();

    const details = arching?.details
        .filter(detail => detail.cashType === cashTypes.cash)
        .filter(detail => detail.currency && !!business.currencies.find(x => x === detail.currency)) || [];

    return (
        <>
            {loading && <Spinner message="Cargando" lockScreen />}
            <Grid container spacing={1}>
                {
                    !loading &&
                    <Grid size={12}>
                        <Box component={Paper} padding={2}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                                        <Typography variant='h4'>Arqueo</Typography>
                                        <Typography variant='subtitle1'>{arching?.userEmail} - {utils.formatDate(arching?.created)}</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={12}>
                                    <Divider />
                                </Grid>
                                <Grid size={12}>
                                    <Info
                                        isTitles
                                        price="Cotización"
                                        ingress="Total"
                                        egress="Real"
                                        total="Diferencia"
                                        lastClosureAmount="Apertura"
                                        highlight
                                        color
                                    />
                                </Grid>
                                {
                                    details.map((detail, index) =>
                                        <Fragment key={index}>
                                            <Grid size={12}>
                                                <Info
                                                    description={cashTypesFormat[detail.cashType + detail.currency]}
                                                    price={detail.currencyPrice}
                                                    ingress={detail.total}
                                                    egress={detail.real}
                                                    total={detail.diff}
                                                    lastClosureAmount={detail.cashType === cashTypes.cash && detail.openingAmount}
                                                />
                                            </Grid>
                                            {   details.length - 1 > index &&
                                                <Grid size={12}>
                                                    <Divider light variant='middle' />
                                                </Grid>
                                            }
                                        </Fragment>
                                    )
                                }
                            </Grid>
                        </Box>
                    </Grid>
                }
            </Grid>
        </>
    );
}

export default ArchingDetail;